import type { Components, Theme } from '@mui/material'

export const MuiContainer: Components<Omit<Theme, 'components'>>['MuiContainer'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      paddingLeft: theme.spacing(4),
      paddingRight: theme.spacing(4),
    }),
  },
  variants: [{ props: { disableGutters: true }, style: { paddingLeft: 0, paddingRight: 0 } }],
}
